import { IBusinessOnboardStep } from '@query'

import { getGroupStatus } from './companionStepState'

export const getStepCredits = (step: IBusinessOnboardStep): number => {
  if (getGroupStatus(step) === 'done' && !step.credits_granted_at) {
    return 0
  }
  return step.credit_reward ?? 0
}

export const getStepCreditsEarned = (step: IBusinessOnboardStep): number =>
  step.credits_granted_at ? getStepCredits(step) : 0

export const getCompanionCreditTotals = (steps: IBusinessOnboardStep[]) => {
  const stepTotal = steps.reduce((sum, step) => sum + getStepCredits(step), 0)
  const earnedSteps = steps.reduce((sum, step) => sum + getStepCreditsEarned(step), 0)

  return {
    total: stepTotal,
    earned: earnedSteps
  }
}
